import { Head, Link } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import { formatDate as formatDateUtil } from "@/lib/date-utils"
import type { BreadcrumbItem } from "@/types"

interface IncidentReport {
  id: number
  case_id: number
  report_date: string | null
  author_name: string | null
  case_name: string | null
  num_entries: number
  status: string
}

interface Props {
  reports: IncidentReport[]
}

function formatDate(dateStr: string | null): string {
  return formatDateUtil(dateStr, {
    month: "numeric",
    day: "numeric",
    year: "numeric",
  })
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Reports", href: "#" },
  { title: "Incident Reports", href: "/reports/incident_reports" },
]

export default function IncidentReports({ reports }: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Incident Reports" />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Incident Reports</h1>

        {reports.length > 0 ? (
          <div className="border-hpi-light-gray rounded border bg-white">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-hpi-light-gray border-b bg-gray-50">
                  <th className="px-4 py-3 text-left font-medium">Date</th>
                  <th className="px-4 py-3 text-left font-medium">By</th>
                  <th className="px-4 py-3 text-left font-medium">Case</th>
                  <th className="px-4 py-3 text-left font-medium">Status</th>
                </tr>
              </thead>
              <tbody>
                {reports.map((report) => (
                  <tr
                    key={report.id}
                    className="border-hpi-light-gray border-b last:border-0"
                  >
                    <td className="px-4 py-3">
                      <Link
                        href={`/cases/${report.case_id}/reports/${report.id}`}
                        className="text-hpi-active-blue"
                      >
                        {formatDate(report.report_date)}
                      </Link>
                    </td>
                    <td className="px-4 py-3">
                      <Link
                        href={`/cases/${report.case_id}/reports/${report.id}`}
                        className="text-hpi-active-blue"
                      >
                        {report.author_name}
                      </Link>
                    </td>
                    <td className="px-4 py-3">
                      <Link
                        href={`/cases/${report.case_id}/reports/${report.id}`}
                        className="text-hpi-active-blue"
                      >
                        {report.case_name}{" "}
                        <span className="text-gray-500">
                          ({report.num_entries})
                        </span>
                      </Link>
                    </td>
                    <td className="px-4 py-3">
                      <Link
                        href={`/cases/${report.case_id}/reports/${report.id}`}
                        className="text-hpi-active-blue"
                      >
                        {report.status}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="rounded border border-red-300 bg-red-50 p-4 text-center text-red-700">
            No Incident Reports found
          </div>
        )}
      </div>
    </AppLayout>
  )
}
